import type { CSSProperties } from "react";

/**
 * The LogicLine Raute (parallelogram) as a board's mark, tinted per workspace —
 * the "thing" counterpart to a person's coloured circle (people = circle, boards
 * = Raute). A skewed rounded square: scales to any size, takes any colour, no
 * image. Same brand shape as the SSO button's mark.
 */
export function RauteMark({ color, size = 9 }: { color: string; size?: number }) {
  const style: CSSProperties = {
    width: size,
    height: size,
    borderRadius: 2,
    background: color,
    transform: "skewX(-12deg)",
    flexShrink: 0,
    display: "inline-block",
  };
  return <span aria-hidden style={style} />;
}
